export default function ViewOffFill()
{
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <g id="Website_10-14" data-name="Website 10-14">
        <path d="M86,50,67,31a24,24,0,0,0-33.32-.55l-14-14L16.5,19.69,30.42,33.61,14,50,33,69a24,24,0,0,0,33.32.56l14,14,3.19-3.19L69.58,66.39ZM50,33A17,17,0,0,1,63.53,60.34l-4.29-4.29a10.91,10.91,0,0,0,1.82-6A11,11,0,0,0,50,39v7.84L39.67,36.48A17,17,0,0,1,50,33Zm0,34A17,17,0,0,1,36.47,39.66L40.76,44a10.91,10.91,0,0,0-1.82,6A11.05,11.05,0,0,0,56,59.23l4.29,4.29A17,17,0,0,1,50,67Z" />
      </g>
    </svg>
  )
}